<div class="forgot-pwd-comp-container">
  <div class="forgot-pwd-form">
    <div class="header">
      <button
        pButton
        (click)="backButton()"
        class="back-button"
        severity="secondary"
        icon="ph ph-caret-left"
        aria-label="Back"></button>
      <span class="title-text">{{ 'doktar_app.auth.forgot_password_title' | translate }}</span>
      <span class="subtitle-text">
        {{ 'doktar_app.auth.forgot_password_description' | translate }}
      </span>
    </div>
    @if (loginInputType === 'email') {
      <span class="forgot-pwd-email-input-label">
        {{ 'doktar_app.auth.login.email_label' | translate }}
      </span>

      <input
        pInputText
        class="forgot-pwd-email-input-text"
        type="email"
        name="email"
        [(ngModel)]="email"
        #emailInput="ngModel"
        [placeholder]="'doktar_app.common.email_placeholder' | translate"
        [email]="true" />
    } @else if (loginInputType === 'phone') {
      <span class="phone-input-label">
        {{ 'doktar_app.common.phone_number_label' | translate }}
      </span>
      <div class="phone-number-input-container">
        <p-select
          [options]="countries"
          [(ngModel)]="selectedCountry"
          optionLabel="name"
          [filter]="true"
          filterBy="name,phoneCode"
          [showClear]="false"
          appendTo="body"
          class="country-selector">
          <ng-template #selectedItem let-selectedOption>
            <div class="country-flag">
              <span class="flag-emoji view-only" [attr.title]="selectedOption.name">
                {{ selectedOption.flagEmoji | unicodeToEmoji }}
                {{ selectedOption.phoneCode }}
              </span>
            </div>
          </ng-template>
          <ng-template let-country #item>
            <div class="country-flag">
              <span class="flag-emoji" [attr.title]="country.name">{{ country.flagEmoji | unicodeToEmoji }}</span>
              <div>{{ country.phoneCode + ' ' + country.name }}</div>
            </div>
          </ng-template>
        </p-select>
        <p-inputNumber
          class="phone-number-input-mask"
          mask="999-999-99-99"
          [(ngModel)]="phoneNumber"
          [useGrouping]="false"
          [minlength]="6"
          [maxlength]="11" />
      </div>
    }

    <div class="forgot-pwd-buttons">
      @if (somethingWentWrong) {
        <div class="error-container">
          <span class="error-text">
            {{ errorMessage }}
          </span>
        </div>
      }
      <button
        pButton
        (click)="confirmForgotPassword()"
        class="continue-button"
        [label]="'doktar_app.common.continue' | translate"
        [disabled]="(loginInputType === 'email' && !email) || (loginInputType === 'phone' && !phoneNumber)"></button>
    </div>
  </div>
</div>
